import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { LiksDialog } from '../../components/liks/LiksDialog/LiksDialog';
import { useI18n } from '../../i18n/useI18n';
import './LacCrawlSelectedUrlsLevelInfoModal.css';

export type LacCrawlSelectedUrlsLevelInfoKind = 'collapse' | 'expand';

type LacCrawlSelectedUrlsLevelInfoModalProps = {
  kind: LacCrawlSelectedUrlsLevelInfoKind;
  onClose: () => void;
};

export function LacCrawlSelectedUrlsLevelInfoModal({
  kind,
  onClose,
}: LacCrawlSelectedUrlsLevelInfoModalProps) {
  const { translate } = useI18n();

  const title =
    kind === 'collapse'
      ? translate('knowledge.crawlSelectionCollapseLevel')
      : translate('knowledge.crawlSelectionExpandLevel');
  const description =
    kind === 'collapse'
      ? translate('knowledge.crawlSelectionCollapseLevelTooltip')
      : translate('knowledge.crawlSelectionExpandLevelTooltip');

  return (
    <LiksDialog
      isOpen
      size="sm"
      title={title}
      onClose={onClose}
      closeLabel={translate('knowledge.form.close')}
      footer={
        <LiksButton type="button" onClick={onClose}>
          {translate('knowledge.form.close')}
        </LiksButton>
      }
    >
      <p className="lac-crawl-urls-dialog__info-description">{description}</p>
    </LiksDialog>
  );
}
